import React from 'react';
import HeroCard from '../cards/HeroCard';

const StartNowSection = ({ id }, ref) => {
    return (
        <section id={id} ref={ref}>
            <HeroCard />
        </section>
    );
};

export default React.forwardRef(StartNowSection);
